// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"586":"7309a829","1469":"56a1eb50","5291":"56a1eb50","8368":"56a1eb50"}[chunkId] + ".chunk.css";
};